import type { SupportedLanguage } from "@/generated/fastapi";
import { franc } from "franc";
import { iso6393To1 } from "iso-639-3";
import { SUPPORTED_LANGUAGE_CODES } from "@/shared/config/backend";

export const languageCodeToNameMap: Record<string, string> = {
  en: "English",
  sk: "Slovak",
  de: "German",
};

export function detectLanguageCode(
  text: string,
  minLength: number = 10,
): string {
  if (!text || text.length < minLength) {
    return "unknown";
  }

  try {
    const iso6393Code = franc(text);

    if (iso6393Code === "und") {
      return "unknown";
    }

    const iso6391Code = iso6393To1[iso6393Code];
    return iso6391Code || "unknown";
  } catch {
    return "unknown";
  }
}

export function detectLanguageName(text: string): string {
  const langCode = detectLanguageCode(text);
  return languageCodeToNameMap[langCode] || "Unknown";
}

export function detectLanguageDetails(text: string): {
  code: string;
  name: string;
} {
  const code = detectLanguageCode(text);
  return {
    code,
    name: languageCodeToNameMap[code] || "Unknown",
  };
}

export function resolveSupportedLanguage(
  language: string | null | undefined,
): SupportedLanguage | "" {
  if (!language || language === "unknown") {
    return "";
  }

  if (
    SUPPORTED_LANGUAGE_CODES.includes(
      language as (typeof SUPPORTED_LANGUAGE_CODES)[number],
    )
  ) {
    return language as SupportedLanguage;
  }

  return "";
}
